import { render, staticRenderFns } from "./ProductLeaderSelect.vue?vue&type=template&id=6f5fc2a0&scoped=true"
import script from "./ProductLeaderSelect.vue?vue&type=script&lang=js"
export * from "./ProductLeaderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5fc2a0",
  null
  
)

export default component.exports